/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/interfaces"/>
import { ListItem, SortInfo } from "@medius/ui-controls";

export enum RejectManagementWizardType {
    Delete,
    Invalidate,
    InvalidateAndEdit
}

export interface IRejectManagementReasonCode {
    id: number;
    reasonCode: string;
    description: string;
    systemReasonCode: string;
    operations: string[];
    types: string[];
    isSystemReasonCode: boolean;
    rejectionActionId? : number | null
}

export interface IRejectionAction{
    id: number;
    code: string;
}

export interface ISupplierInvoiceRejectionDto {
    documentId: number;
    invoiceRejectionReasonItems: IInvoiceRejectionReasonItem[];
    sendToSupplier: boolean;
    invoiceRejectionEmail?: IInvoiceRejectionEmailDto;
}

export interface IInvoiceRejectionEmailDto {
    emailTo: string;
    sendCopy: boolean;
    messageSubject: boolean;
    content: string;
}

export interface IInvoiceRejectionReasonItem{
    reasonCodeId: number;
    actionId?: number | null;
}

export interface IInvoiceReasonCodeData {
    invoiceReasonCodes: IRejectManagementReasonCode[];
    forceReasonCode: boolean;
    totalInvoiceReasonCodeCount: number;
    actions: ListItem[];
    isLoading: boolean;
    isError: boolean;
    paging: {
        currentPage: number;
        pageSize: number;
        changePage: (newPage: number) => void;
        changePageSize: (newPageSize: number) => void;
    };
    sorting: {
        sortInfo: SortInfo | null;
        changeSortInfo: (sortInfo: SortInfo | null) => void;
    };
    searching: {
        changeSearchTerm: (term: string) => void;
    };
}

export interface IEmailSettings { 
    CurrentUserEmail : string;
    CurrentUserLanguageCode : string;
}

export interface IRejectionAction{
    id: number,
    code: string
}